export enum GraveType {
  WellKnown = 1,
  Unknown = 2,
  Old = 3,
}
